var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    class: _vm.classes
  }, [_vm.tag ? [_vm.multiple && _vm.checkAll ? _c("Tag", {
    staticClass: "my-tag-select__tag",
    attrs: {
      type: "primary",
      size: _vm.size,
      effect: _vm.isAll ? "dark" : "light"
    },
    on: {
      click: _vm.handleCheckAll
    }
  }, [_vm._v("全部 ")]) : _vm._e(), _vm._l(_vm.optionsComputed, function (item, index) {
    return _c("Tag", {
      key: index,
      class: {
        "my-tag-select__tag": true,
        "is-disabled": item.disabled,
        "is-checked": _vm.isChecked(item)
      },
      attrs: {
        type: "primary",
        size: _vm.size,
        effect: _vm.isChecked(item) ? "dark" : "light"
      },
      on: {
        click: function click($event) {
          return _vm.handleChecked(item);
        }
      }
    }, [_vm._t("default", function () {
      return [_vm._v(_vm._s(item.label))];
    }, {
      item: item,
      index: index
    })], 2);
  })] : [_vm.multiple && _vm.checkAll ? _c("span", {
    class: {
      "my-tag-select__tag": true,
      "is-checked": _vm.isAll
    },
    on: {
      click: _vm.handleCheckAll
    }
  }, [_vm._v("全部")]) : _vm._e(), _vm._l(_vm.optionsComputed, function (item, index) {
    return _c("span", {
      key: index,
      class: {
        "my-tag-select__tag": true,
        "is-disabled": item.disabled,
        "is-checked": _vm.isChecked(item)
      },
      on: {
        click: function click($event) {
          return _vm.handleChecked(item);
        }
      }
    }, [_vm._t("default", function () {
      return [_vm._v(_vm._s(item.label))];
    }, {
      item: item,
      index: index
    })], 2);
  })], _vm.collapsible ? _c("a", {
    staticClass: "my-tag-select__expand",
    on: {
      click: _vm.toggleCollapse
    }
  }, [_vm.currentCollapsed ? [_vm._v(" 展开 "), _c("i", {
    staticClass: "el-icon-arrow-down"
  })] : [_vm._v(" 收起 "), _c("i", {
    staticClass: "el-icon-arrow-up"
  })]], 2) : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };